// extracted by mini-css-extract-plugin
export default {"wrapper":"fM2PJlkFSvfc5tgTE9T_","addButton":"GZw1YZqTNPvf5oXc7aJd"};